export type UiHomePage = 'dashboard' | 'tracks' | 'triage' | 'activity';
export type UiLanguage = 'fr' | 'en' | 'de';

export const UI_HOME_PAGES: UiHomePage[] = ['dashboard', 'tracks', 'triage', 'activity'];
export const UI_LANGUAGES: UiLanguage[] = ['fr', 'en', 'de'];

export function normalizeHomePage(value?: string | null): UiHomePage {
    if (value === 'tracks' || value === 'triage' || value === 'activity' || value === 'dashboard')
        return value;
    return 'dashboard';
}

export function normalizeUiLanguage(value?: string | null): UiLanguage | undefined {
    if (value === 'fr' || value === 'en' || value === 'de')
        return value;
    return undefined;
}

/** Path for a home-page preference (dashboard → `/`). */
export function pathForHomePage(homePage?: string | null): string {
    switch (normalizeHomePage(homePage)) {
        case 'tracks':
            return '/users/tracks';
        case 'triage':
            return '/triage';
        case 'activity':
            return '/users/activity';
        case 'dashboard':
        default:
            return '/';
    }
}
